<div class="navigation-menu-header">
    <div class="navigation-menu-header__name" (click)="backEvent.emit()">
        @if (hasBackArrow()) {
            <mat-icon svgIcon="ico_caret_left" />
        }
        <p>{{ title() }}</p>
    </div>
    <button class="close-icon" #closeButton aria-label="Close" type="button" (click)="closeEvent.emit()">
        <mat-icon svgIcon="ico_close"></mat-icon>
    </button>
</div>
